import { render } from "./FilesPrograms.vue?vue&type=template&id=1ec745de"
import script from "./FilesPrograms.vue?vue&type=script&lang=js"
export * from "./FilesPrograms.vue?vue&type=script&lang=js"

import "./FilesPrograms.vue?vue&type=style&index=0&id=1ec745de&lang=scss"
script.render = render

export default script